import { UploadStoreModule } from './upload-store.module';
import * as FeatureStoreActions from './upload.actions';
import * as FeatureStoreReducer from './upload.reducer';
import * as FeatureStoreSelectors from './upload.selectors';

export * from './upload.interfaces';
export {
  FeatureStoreActions,
  FeatureStoreSelectors,
  FeatureStoreReducer,
  UploadStoreModule,
};
